export const AI_CONFIRM_CARD_DEFAULT_LABELS = {
  approve: 'Approve',
  dismiss: 'Decline',
  reasonPlaceholder: 'Reason (optional)',
  reasonSubmit: 'Confirm decline',
  reasonCancel: 'Cancel',
  slaGroupLabel: 'SLA group',
  slaGroupPlaceholder: 'Choose an SLA group',
  slaGroupPrompt: 'Choose an SLA group before approving.',
};
